import React from "react";
import sharedStyles from "../styles/SharedStyles.module.css";
import caveStraightLeft from "../assets/cave_straight_left.png";

const Room4 = ({ goToRoom7, goToRoom8, goBack }) => {
  return (
    <div className={sharedStyles.centeredContainer}>
      <h1 className={sharedStyles.pageTitle}>Unnamed Chamber</h1>
      <p className={sharedStyles.pageDescription}>
        The walls here are uneven, carved by time and unseen forces.
      </p>

      <div className={sharedStyles.sceneContainer}>
        {/* Room Image */}
        <img
          src={caveStraightLeft}
          alt="Cave Room"
          className={sharedStyles.sceneImage}
        />

        {/* Path Buttons */}
        <button
          className={sharedStyles.button}
          style={{ top: "50%", left: "18%", position: "absolute" }}
          onClick={goToRoom7}
        >
          Left
        </button>
        <button
          className={sharedStyles.button}
          style={{ top: "38%", left: "65%", position: "absolute" }}
          onClick={goToRoom8}
        >
          Right
        </button>
      </div>

      {/* Go Back Button */}
      <button className={sharedStyles.backButton} onClick={goBack}>
        ← Go Back
      </button>
    </div>
  );
};

export default Room4;